<cac-dialog-layout title="Add New Image" submitBtn="Add" (onSubmit)="onSubmit($event)">
    <cac-image-uploader [control]="controller" [options]="options" class="h-44" label="Image" />
    <cac-form-builder [options]="form" class="mt-5"></cac-form-builder>
</cac-dialog-layout>
